<app-view-title [showBack]="false" Title="{{ 'Intellitrailer.Booking.ConfirmedBooking.TitleBookingConfirmation' | translate : 'Booking confirmation' }}"></app-view-title>
<view-content>
    <app-booking-summary *ngIf="booking && this.booking.PrimaryType" [(booking)]="booking" [confirmed]="true"></app-booking-summary>
</view-content>

<view-actions mode="white">
    <button *ngIf="appSettings.appType == 'app'" mat-raised-button (click)="next()">{{ 'Intellitrailer.Navigation.ShowMyBookings' | translate : 'Show my bookings' }}</button>
    <button *ngIf="appSettings.appType == 'web'" mat-raised-button (click)="next()">{{ 'Intellitrailer.Navigation.ReturnStart' | translate : 'Go back to Start' }}</button>
</view-actions>
